import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { FirebaseObjectObservable,
         FirebaseListObservable } from 'angularfire2/database';

import { DBService } from '../../db.service';
import { slide } from '../../animations';

@Component({
  selector: 'show-post',
  templateUrl: './show-post.component.html',
  styleUrls: ['./show-post.component.scss'],
  animations: [slide]
})
export class ShowPostComponent implements OnInit {
  forumObservable: FirebaseObjectObservable<any>;
  postObservable:  FirebaseObjectObservable<any>;
  commentsObservable:  FirebaseListObservable<any[]>;
  forum: any;
  post: any;
  comments: any;
  selectedComment: any;

  showPostFormModal = false;
  showCommentFormModal = false;
  showModalBg = false;
  showDeleteModal = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dbService: DBService
  ) { }

  ngOnInit() {

    this.route.params.forEach((params: Params) => {
      this.forumObservable = this.dbService.getForum(params['forumKey']);
      this.postObservable = this.dbService.getPost(params['forumKey'],
                                                   params['key']);
      this.commentsObservable = this.dbService.getComments(params['key']);

      this.forumObservable.subscribe(forum => {
        this.forum = forum;
      });

      this.postObservable.subscribe(post => {
        this.post = post;
      });
    });
  }

  onAddCommentClicked() {
    this.selectedComment = null;
    this.showModalBg = true;
    this.showCommentFormModal = true;
  }

  onEditCommentClicked(comment, event) {
    event.stopPropagation();
    this.selectedComment = comment;
    this.showModalBg = true;
    this.showCommentFormModal = true;
  }

  onDeleteCommentClicked(comment, event) {
    event.stopPropagation();
    this.selectedComment = comment;
    this.showModalBg = true;
    this.showDeleteModal = true;
  }

  onDeletePostClicked() {
    event.stopPropagation();
    this.selectedComment = null;
    this.showModalBg = true;
    this.showDeleteModal = true;
  }

  onConfirmDelete() {
    if (this.selectedComment) {
      this.dbService.deleteComment(this.post.$key, this.selectedComment.$key);
    } else {
      this.dbService.deletePost(this.forum.$key, this.post.$key);
      this.router.navigate([`/forums/${this.forum.$key}`]);
    }

    this.showModalBg = false;
    this.showDeleteModal = false;
  }

  onEditPostClicked() {
    event.stopPropagation();
    this.showModalBg = true;
    this.showPostFormModal = true;
  }

  onHidePostFormModal() {
    this.showPostFormModal = false;
    this.showModalBg = false;
  }

  onHideCommentFormModal() {
    this.showCommentFormModal = false;
    this.showModalBg = false;
  }

  onHideDeleteModal() {
    this.showDeleteModal = false;
    this.showModalBg = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/forums/show-post/show-post.component.ts